import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import ClassNames from 'classnames';
import { SortableContainer, arrayMove } from 'react-sortable-hoc';
import { ListGroup } from 'reactstrap';
import ListItem from './Item';

class List extends React.Component {
  constructor(props) {
    super();
    this.state = {
      contents: props.items || []
    };

    // Binds
    this.onSortEnd = this.onSortEnd.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      contents: nextProps.items
    });
  }
  onSortEnd({ oldIndex, newIndex }) {
    const newContents = arrayMove(
      this.state.contents,
      oldIndex,
      newIndex < this.state.contents.length
        ? newIndex
        : this.state.contents.length - 1
    );
    this.setState({
      contents: newContents
    });
    this.props.sort(newContents);
    if (typeof this.props.onSortEnd === 'function') this.props.onSortEnd(newContents);
  }
  render() {
    const {
      items,
      parentClassName,
      listGroup = true,
      sortable,
      sort,
      showMore,
      onSortEnd,
      ...rest
    } = this.props;
    if (sortable) {
      const SortableList = SortableContainer(() => {
        if (listGroup) {
          return (
            <ListGroup
              className={ClassNames('mb-3', {
                [parentClassName]: !!parentClassName
              })}
            >
              {this.state.contents.map((item, index) => (
                <ListItem
                  sortable
                  key={uuid.v4()}
                  index={index}
                  order={index}
                  data={item}
                  onIndexChange={this.onSortEnd}
                  {...rest}
                />
              ))}
            </ListGroup>
          );
        }

        return (
          <div
            className={ClassNames('mb-3 col-12 mt-2', {
              [parentClassName]: !!parentClassName
            })}
          >
            {this.state.contents.map((item, index) => (
              <ListItem
                sortable
                key={uuid.v4()}
                index={index}
                order={index}
                data={item}
                onIndexChange={this.onSortEnd}
                {...rest}
              />
            ))}
          </div>
        );
      });
      return (
        <SortableList onSortEnd={this.onSortEnd} {...rest} />
      );
    }

    if (listGroup) {
      return (
        <ListGroup
          className={ClassNames('mb-3', {
            [parentClassName]: !!parentClassName
          })}
        >
          {this.state.contents.map((item, index) => (
            <ListItem
              key={uuid.v4()}
              index={index}
              order={index}
              data={item}
              {...rest}
            />
          ))}
          {showMore}
        </ListGroup>
      );
    }

    return (
      <div
        className={ClassNames('mb-3', {
          [parentClassName]: !!parentClassName
        })}
      >
        {this.state.contents.map((item, index) => (
          <ListItem
            key={uuid.v4()}
            index={index}
            order={index}
            data={item}
            {...rest}
          />
        ))}
        {showMore}
      </div>
    );
  }
}

export default List;

List.propTypes = {
  items: PropTypes.array,
  sort: PropTypes.func,
  parentClassName: PropTypes.string,
  listGroup: PropTypes.bool,
  sortable: PropTypes.bool,
  showMore: PropTypes.object
};
List.defaultProps = {
  items: null,
  sort: null,
  parentClassName: null,
  listGroup: true,
  sortable: false,
  showMore: null
};
